import { useContext } from "react";
import { useAddUpdateAddressModal } from "../../../../Account/useAddUpdateAddressForm/useAddUpdateAddressModal";
import { UpdateOrderDeliveryPickupModalContext } from "../../../../Account/useUpdateOrderDeliveryModal/deliveryModalUtils/UpdateOrderDeliveryPickupModalContext";
import { createRemappingModalAddressLine, getIsPickupLocation, isDeliveryAddress, shouldUseBorderAsSelected, } from "../utils/addressCardUtils";
export const useAddressCard = (refetchAddresses, deliveryQuestions, geoLocationCoords, address, orderId, orderStatus, isUpdateOrderModal, initTabProps) => {
    var _a, _b, _c, _d, _e, _f;
    const { newAddressData, setNewAddressData } = useContext(UpdateOrderDeliveryPickupModalContext);
    const { showAddUpdateAddressModal } = useAddUpdateAddressModal(refetchAddresses, deliveryQuestions, geoLocationCoords, address);
    const isDeliveryAddressCard = isDeliveryAddress(address);
    const isPrimaryAddress = isDeliveryAddressCard ? address === null || address === void 0 ? void 0 : address.isPrimary : false;
    const name = isDeliveryAddressCard ? `${(_a = address === null || address === void 0 ? void 0 : address.firstName) !== null && _a !== void 0 ? _a : ""} ${(_b = address === null || address === void 0 ? void 0 : address.lastName) !== null && _b !== void 0 ? _b : ""}` : (_c = address.name) !== null && _c !== void 0 ? _c : "";
    const isPickupLocation = getIsPickupLocation(address);
    const currentAddressCardData = {
        address_id: (_d = address === null || address === void 0 ? void 0 : address.addressId) !== null && _d !== void 0 ? _d : "",
        LocationId: (isPickupLocation && (address === null || address === void 0 ? void 0 : address.LocationId)) || "",
        location_sku: (_e = address === null || address === void 0 ? void 0 : address.locationSku) !== null && _e !== void 0 ? _e : "",
        locationName: (isPickupLocation && (address === null || address === void 0 ? void 0 : address.name)) || "",
        order_id: orderId,
        order_status: orderStatus,
        streetAddress: (address && createRemappingModalAddressLine(address)) || "",
        zip: (_f = address === null || address === void 0 ? void 0 : address.zip) !== null && _f !== void 0 ? _f : "",
    };
    const cardStyle = shouldUseBorderAsSelected(isUpdateOrderModal, isPrimaryAddress, isDeliveryAddressCard, newAddressData, currentAddressCardData, initTabProps);
    return {
        showAddUpdateAddressModal,
        name,
        isDeliveryAddressCard,
        isPickupLocation,
        currentAddressCardData,
        cardStyle,
        setNewAddressData,
    };
};
